module.exports = __webpack_public_path__ + "img/backgroundImg.39517804.jpeg";